import styled from "styled-components";

const Header = styled.h2`
  margin-top: 20px;
`;

export default Header;
